// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { Link, makeStyles, tokens, Tooltip } from '@fluentui/react-components';
import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { isBeta } from '../../data';
import { InAppFeedbackContext } from './in-app-feedback';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        textWrap: 'nowrap',
        paddingTop: tokens.spacingVerticalXS,
        paddingBottom: tokens.spacingVerticalXS,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        marginLeft: tokens.spacingHorizontalM,
        color: tokens.colorStatusWarningForeground2,
        backgroundColor: tokens.colorStatusWarningBackground2,
        borderRadius: tokens.borderRadiusCircular,
    },
});

// Beta version indicator.
export const BetaIndicator: FC = () => {
    const styles = useStyles();
    const feedbackContext = useContext(InAppFeedbackContext);
    if (isBeta) {
        return (
            <Tooltip
                relationship="description"
                content={
                    <FormattedMessage
                        defaultMessage="You are using pre-release version of VS Code for Education. If you encounter any issues or have suggestions, please report them via {GIVE_FEEDBACK_LINK} option."
                        description="Beta version indicator tooltip"
                        values={{
                            GIVE_FEEDBACK_LINK: (
                                <Link onClick={() => feedbackContext.launch()}>
                                    <FormattedMessage
                                        description="Link on the Beta release indicator tooltip."
                                        defaultMessage="Give Feedback"
                                    />
                                </Link>
                            ),
                        }}
                    />
                }
            >
                <div className={styles.root}>
                    <FormattedMessage defaultMessage="Beta release" description="Beta version indicator." />
                </div>
            </Tooltip>
        );
    } else {
        return null;
    }
};

export default BetaIndicator;
